import React, { useState, useEffect } from 'react';
import QuizSidebarLoader from "./../Loader/QuizSidebarLoader";
import 'react-confirm-alert/src/react-confirm-alert.css';
import classNames from 'classnames';
import { Drawer } from '@material-ui/core';
import QuizSectionMap from "./QuizSectionMap";
import QuizStatus from "./QuizStatus";
import QuizCompactResult from "./QuizCompactResult";
import { useSelector } from "react-redux";
import { useScreenWidth, useStyles } from "examsbook-react-sdk/custom-hooks";

const drawerWidth = 320;

/**
 * QuizSidebar
 * @param props
 * @returns {*}
 * @constructor
 */
function QuizSidebar(props) {
    const {
        viewMode, selectPaletteQuestion,
        result, isLoading, timeTaken, changeSectionActive, duration, handler, drawerToggle
    } = props;
    const classes = useStyles(styles)();
    const [ openIndex, setOpenIndex ] = useState(0);
    const questions = useSelector((state) => state.quiz.questions);
    const screenWidth = useScreenWidth();

    useEffect(() => {
        if (openIndex !== changeSectionActive) {
            setOpenIndex(changeSectionActive);
        }
    }, [ changeSectionActive, openIndex ]);

    function drawerClose() {
        handler();
    }

    function mobileDrawerClose() {
        if (screenWidth <= 488) {
            handler();
        }
    }

    function handleSectionChange(i) {
        if (openIndex === i) {
            setOpenIndex('');
        } else {
            setOpenIndex(i);
        }
    }

    let counter = 0;
    return (
        <div>
            <div className={classNames(classes.sidebarIconRight)} onClick={drawerClose}>
                <i className="fa fa-arrow-right"/>
            </div>
            {screenWidth > 767 && screenWidth < 1025 ?
                <Drawer
                    className={classes.drawer}
                    variant="permanent"
                    classes={{
                        paper: !drawerToggle ? classes.drawerClosed : classes.drawerPaper
                    }}
                >
                    <div>
                        <div className={classes.questionNumberBlock}>
                            <div className={classNames(classes.sidebarIconLeft)}>
                                <i className="fa fa-arrow-left" onClick={drawerClose}/>
                            </div>
                            {
                                !isLoading ? <React.Fragment>
                                    <QuizCompactResult viewMode={viewMode} questions={questions} timeTaken={timeTaken}
                                                       duration={duration}/>
                                    <QuizStatus result={result} viewMode={viewMode} questions={questions}/>
                                    <div className={classNames(classes.quizSidebarAccordion)}
                                         onClick={mobileDrawerClose}>
                                        {
                                            questions.map((item, i) => {
                                                if (i > 0) {
                                                    counter += questions[i - 1].questions.length;
                                                }
                                                return (
                                                    <QuizSectionMap key={i} index={i} counter={counter} item={item}
                                                                    selectPaletteQuestion={selectPaletteQuestion}
                                                                    viewMode={viewMode} openIndex={openIndex}
                                                                    handleSectionChange={handleSectionChange}/>
                                                );

                                            })
                                        }
                                    </div>

                                </React.Fragment> : <div><QuizSidebarLoader/></div>
                            }

                        </div>
                        {/* <InstructionsButton handler={handler} viewMode={viewMode} mode={mode} submitQuiz={submitQuiz}  toggleInstructionBox={toggleInstructionBox}/>*/}
                    </div>
                </Drawer>
                :
                <Drawer
                    className={classes.drawer}
                    variant="permanent"
                    classes={{
                        paper: drawerToggle ? classes.drawerClosed : classes.drawerPaper
                    }}
                >
                    <div>
                        <div className={classes.questionNumberBlock}>
                            <div className={classNames(classes.sidebarIconLeft)}>
                                <i className="fa fa-arrow-left" onClick={drawerClose}/>
                            </div>
                            {
                                !isLoading ? <React.Fragment>
                                    <QuizCompactResult viewMode={viewMode} questions={questions} timeTaken={timeTaken}
                                                       duration={duration}/>
                                    <QuizStatus result={result} viewMode={viewMode} questions={questions}/>
                                    <div className={classNames(classes.quizSidebarAccordion)}
                                         onClick={mobileDrawerClose}>
                                        {
                                           questions && questions.map((item, i) => {
                                                if (i > 0) {
                                                    counter += questions[i - 1].questions.length;
                                                }
                                                return (
                                                    <QuizSectionMap key={i} index={i} counter={counter} item={item}
                                                                    selectPaletteQuestion={selectPaletteQuestion}
                                                                    viewMode={viewMode} openIndex={openIndex}
                                                                    handleSectionChange={handleSectionChange}/>
                                                );

                                            })
                                        }
                                    </div>

                                </React.Fragment> : <div><QuizSidebarLoader/></div>
                            }

                        </div>
                        {/*<InstructionsButton handler={handler} viewMode={viewMode} mode={mode} submitQuiz={submitQuiz}  toggleInstructionBox={toggleInstructionBox}/>*/}
                    </div>
                </Drawer>
            }
        </div>
    );
}

const styles = theme => ({
    sidebarIconLeft: {
        textAlign: 'right',
        padding: 10,
        color: '#000',
        position: 'absolute',
        top: 6,
        right: 4,
        zIndex: 9,
        '& i': {
            cursor: 'pointer'
        },
        '@media (max-width: 767px)': {
            display: 'none'
        }
    },
    quizSidebarAccordion: {
        marginLeft: 15,
        marginRight: 15,
        '@media (max-width: 767px)': {
            marginLeft: 10,
            marginRight: 10,
            marginTop: 50,
            paddingBottom: 30
        },
        '& > div': {
            boxShadow: 'none',
            marginBottom: '15px !important',
            backgroundColor: '#f7fefd',
        }
    },
    marginTop: {
        marginTop: 10,
    },
    questionNumberBlock: {
        height: 'calc(100vh - 66px)',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            width: 5,
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#d3d5d3'
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#eeecec'
        },
        '@media (max-width: 767px)': {
            height: 'calc(100vh - 50px)',
        }
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        zIndex: 0,
        width: drawerWidth,
        top: 66,
        bottom: 0,
        backgroundColor: '#f7fefd',
        borderWidth: 1,
        borderLeftColor: '#ddd',
        height: 'auto',
        overflow: 'hidden',
        transition: '0.3s ease-in-out',

        '@media (max-width:767px)': {
            width: '100%',
            top: 55,
            bottom: 0,
            opacity: 1,
            zIndex: 1000
        },
        '@media (max-width: 1100px) and (min-width: 768px)': {
            zIndex: 99,
        }
    },
    drawerClosed: {
        width: drawerWidth,
        top: 66,
        bottom: 10,
        backgroundColor: '#fff',
        borderWidth: 1,
        borderLeftColor: '#ddd',
        boxShadow: '0 0 15px #aaa',
        height: 'auto',
        transition: '0.3s ease-in-out',
        overflow: 'hidden',
        transform: 'translate(-330px)',
        '@media (max-width:767px)': {
            width: '100%',
            top: 55,
            zIndex: -1000,
            bottom: 0,
            transform: 'unset',
            opacity: 0
        }
    },
    sidebarIconRight: {
        position: 'fixed',
        top: 70,
        left: 0,
        padding: 10,
        backgroundColor: '#fff',
        boxShadow: '0 0 15px #aaa',
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4,
        cursor: 'pointer',
        '@media(max-width:767px)': {
            display: 'none'
        }
    }
});
export default QuizSidebar;

